module.exports = __webpack_public_path__ + "img/T6-C-xs_3.f74db28c.png";